import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import { Font14 } from 'components/Typography'

export const StyledSearchContainer = styled.div`
  position: relative;
  z-index: 1;
  background-color: ${theme.colors.white};
  box-shadow: inset 0 0 0 1px ${theme.colors.lightGrey};
  border-radius: 8px;
  display: flex;
  padding: 8px 16px;
  transition: all 0.3s ease;
  width: 100%;
  :focus-within {
    box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange};
  }
`

export const StyledInput = styled.input`
  font-weight: normal;
  ${Font14};
  background-color: transparent;
  border: none;
  margin-left: 8px;
  width: 100%;
  padding: 0;
  transition: all 0.3s ease;
  outline: none;
  ::placeholder {
    color: ${theme.colors.darkeyGrey};
  }
`

export const StyledClearSearchBtn = styled.button`
  position: absolute;
  z-index: 2;
  top: 6px;
  right: 3px;
  background: transparent;
  border: none;
  cursor: pointer;
`

export const StyledClearSearchIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`
